<div [ngClass]="{ 'menu-opened': opened, 'menu-closed': !opened }" class="menu-content">
  <div>
    <div *ngFor="let item of menuSidebar">
      <div flexLayout="start center" *ngIf="item.hasPermission && !item.sub_menu">
        <button
          [ngStyle]="{ 'background-color': btnColorValidation() }"
          class="btn-group"
          matTooltip="{{ item.link_name }}"
          matTooltipPosition="after"
          [ngClass]="{ 'btn-on': isPageView(item.isActive), 'btn-menu-closed': !opened }"
          (click)="item.link ? goTo(item.link) : item.sub_menu ? openSubMenu() : ''">
          <mat-icon aria-hidden="false">{{ item.icon }}</mat-icon>
          <span *ngIf="opened" [ngStyle]="{ color: fontColorValidation() }">
            {{ item.link_name }}
          </span>
        </button>
      </div>
      <div flexLayout="start center" *ngIf="item.sub_menu && item.hasPermission">
        <button
          class="btn-group submenus-components"
          [ngStyle]="{ 'background-color': btnColorValidation() }"
          [ngClass]="{ 'submenus-components': opened }"
          matTooltip="{{ item.link_name }}"
          matTooltipPosition="after"
          (click)="item.opened = !item.opened"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin">
          <div class="submenu-align">
            <mat-icon aria-hidden="false">{{ item.icon }}</mat-icon>
            <span [ngStyle]="{ color: fontColorValidation() }" *ngIf="opened">
              {{ item.link_name }}
            </span>
          </div>
          <mat-icon class="arrow" *ngIf="item.sub_menu && opened" iconPositionEnd>chevron_right</mat-icon>
        </button>
        <menu-item  #menu [items]="item.sub_menu" [trigger]="trigger" [openMenu]="item.opened" (closeMenu)="item.opened = false" [isOpened]="opened"></menu-item>
      </div>
    </div>
  </div>

  <div class="menu-bottom">
    <div class="privacy-policy">
      <a [ngClass]="{ 'policy-menu-closed': !opened }" href="/politica-de-privacidade" target="_blank">Aviso de Privacidade</a>
    </div>
    <p class="version">Versão: {{ version }}</p>
  </div>
</div>
